var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvas_mu",staticClass:"canvas_mu"},[_c('canvas',{ref:"canvas",attrs:{"id":_vm.id},on:{"mousedown":_vm.onCanvasMouseDown,"mouseup":_vm.onCanvasMouseUp,"mousemove":_vm.onCanvasMouseMove,"mouseout":_vm.onCanvasMouseOut}}),_vm._v(" "),_c('div')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404ac8df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/muCv.vue
// module id = null
// module chunks = 